import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../../components/header/Header';
import MyProfileItem from '../../../components/profile-item/MyProfileItem';
import { useFujiAuth } from '../../../auth/useFujiAuth';
import ButtonNetwork from '../../../utils/network-connect/ButtonNetwork';
import icMail from '../../../assets/imgs/ic_mail.svg';
import styles from './styles.module.css';

// import TextArea from 'antd/es/input/TextArea';
// import { Divider, Button, notification } from 'antd';

/**
 * 図9-1 ユーザ情報画面
 */
const UserInfo = () => {
    // const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const { t } = useTranslation();
    const { user } = useFujiAuth();
    const navigate = useNavigate();
    // const localUserInfo = JSON.parse(localStorage.getItem(localStorageKeys.FORM_VALUE_WITH_USER) || '{}');
    // const userFormInfo = localUserInfo[user.userId] || {};
    // const { representativeName, countryCode, phoneNumber, email } = userFormInfo;

    // const handelUserFormDelete = () => {
    //     setIsConfirmModalOpen(false);
    //     delete localUserInfo[user.userId];
    //     localStorage.setItem(localStorageKeys.FORM_VALUE_WITH_USER, JSON.stringify(localUserInfo));
    // };

    return (
        <>
            {/* <FujiModal
                isOpen={isConfirmModalOpen}
                onCancel={() => setIsConfirmModalOpen(false)}
                txtCancel={t('modal.delete-cancel')}
                onSubmit={handelUserFormDelete}
                txtSubmit={t('modal.delete')}
                body={
                    <div>
                        <div>{t('modal.delete-user-form-info')}</div>
                        <ul className={styles.formInfo}>
                            <li className={styles.formItem}>{`${t(
                                'reservation.user-name',
                            )}: ${representativeName}`}</li>
                            <li className={styles.formItem}>{`${t('reservation.phone-number')}: ${
                                countryCode?.dialCode
                            }${phoneNumber}`}</li>
                            <li className={styles.formItem}>{`${t('reservation.email-address')}: ${email}`}</li>
                        </ul>
                    </div>
                }
            /> */}
            <Header title={t('my-profile.userinfo')} />
            <div className="content-footer-container scrollable" style={{ position: 'relative' }}>
                <div className={styles.infoProvider}>
                    {user && user.providerName === null && <img width={30} src={icMail} alt="icMail" />}
                    <span>{user && user?.email?.toLowerCase()}</span>
                </div>
                {user && user.providerName === null && (
                    <MyProfileItem to="change-password" title={t('user-info.password') ?? ''} />
                )}
                {user && user.providerName === null && (
                    <MyProfileItem to="change-mail" title={t('user-info.mail') ?? ''} />
                )}

                {/* <Divider>idToken</Divider>
                <TextArea
                    style={{
                        height: 150,
                        resize: 'none',
                    }}
                    value={user && user.idToken}
                ></TextArea>
                <Button
                    style={{ width: '100%' }}
                    onClick={async () => {
                        try {
                            if (user?.idToken) {
                                await global.navigator.clipboard.writeText(user.idToken);
                                notification.success({
                                    description: 'クリップボードにコピーしました。',
                                });
                            }
                        } catch (e) {
                            console.log(e);
                        }
                    }}
                >
                    copy idToken
                </Button> */}

                <div className={styles.btnDelete}>
                    {/* {!isEmptyObject(userFormInfo) && (
                        <Button className={styles.btnDeleteUserForm} block onClick={() => setIsConfirmModalOpen(true)}>
                            {t('button.delete-user-form-info')}
                        </Button>
                    )} */}
                    <ButtonNetwork
                        title={t('user-info.delete-account')}
                        isIcon={false}
                        onClick={() => navigate('delete')}
                    ></ButtonNetwork>
                </div>
            </div>
        </>
    );
};

UserInfo.prototype = {};

export default UserInfo;
